import React, { AllHTMLAttributes, useState } from "react";
import { observer } from "mobx-react-lite";
import cx from "classnames";
import { Hooks } from "@xt/xtbase";
//import store from "store";
import styles from "./index.module.scss";
import Title from "../_CMPT/Title";
import closeImg from "@/assets/images/account/delete-acount.svg";
import CloseAccountModal from "../_CMPT/Modal/CloseAccount";
interface CloseAccountProps extends AllHTMLAttributes<HTMLElement> {
  attr?: any;
}
const { useTranslation } = Hooks;
const CloseAccount: React.FC<CloseAccountProps> = ({ className }) => {
  const t = useTranslation();
  //const {isLogin} = store.user;
  const [modalShow, setModalShow] = useState("");
  return (
    <div className={cx(styles.accountSet, className)}>
      <Title title={t("account.accountControl")}></Title>
      <div className={cx(styles["account_common_list"], styles["account_list_common"])}>
        <div className={styles["account_list_common_left"]}>
          {/* <div>
            <img src={closeImg} alt="" />
          </div> */}
          <div className={styles["account_sign"]}>
            <div className={styles["account_sign_header"]}>
              <span className={styles["account_sign_header_tit"]}>{t("account.closeAccount")}</span>
            </div>
            <div className={styles["account_sign_footer"]}>
              <span className={styles["account_sign_header_desc"]}>
                {t("account.pageTip")}，{t("account.pageTip2")}
              </span>
            </div>
          </div>
        </div>

        <div className={styles["account_list_common_right"]}>
          <span className={cx(styles["no_action"], styles["action"], styles["account-base-btn"], styles["text_update"])} onClick={() => setModalShow("closeAccount")}>
            {t("account.close")}
          </span>
        </div>

        <CloseAccountModal visible={modalShow === "closeAccount"} title={`${t("account.closeAccount")}`} closemodal={() => setModalShow("")} />
      </div>
    </div>
  );
};
export default observer(CloseAccount);
